var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIntegrationResults = function SvgIntegrationResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 41.3149L61.7797 49.9999L48.7325 62.4807M47.3256 58.7098L38.2199 50L51.3222 37.4674M49.5957 38.3495L46.7125 35.5917C44.8963 33.8552 44.8963 31.039 46.7125 29.3024C48.528 27.5659 51.4714 27.5659 53.2877 29.3024C55.1032 31.039 55.1032 33.8552 53.2877 35.5917L50.4046 38.3495C50.181 38.5626 49.8185 38.5626 49.5957 38.3495ZM50.4043 61.6503L53.2874 64.4081C55.1036 66.1454 55.1036 68.9608 53.2874 70.6981C51.4719 72.434 48.5285 72.434 46.7122 70.6981C44.8967 68.9608 44.8967 66.1454 46.7122 64.4081L49.5953 61.6503C49.8189 61.4372 50.1814 61.4372 50.4043 61.6503ZM62.1799 49.6132L65.063 46.8554C66.8793 45.1189 69.8227 45.1189 71.6382 46.8554H71.639C73.4537 48.592 73.4537 51.4074 71.639 53.1447H71.6382C69.8227 54.8813 66.8793 54.8813 65.063 53.1447L62.1799 50.387C61.9571 50.1731 61.9571 49.8264 62.1799 49.6132ZM37.8201 50.3866L34.937 53.1444C33.1207 54.8817 30.1773 54.8817 28.3618 53.1444H28.361C26.5463 51.4078 26.5463 48.5924 28.361 46.8551H28.3618C30.1773 45.1185 33.1207 45.1185 34.937 46.8551L37.8201 49.6129C38.0429 49.8267 38.0429 50.1735 37.8201 50.3866Z",
    stroke: "#000000",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntegrationResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/integration-results.ef050a9b.svg";
export { ForwardRef as ReactComponent };